import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-frequency-selector',
  templateUrl: './frequency-selector.component.html',
  styleUrls: ['./frequency-selector.component.scss'],
  standalone: false,
})
export class FrequencySelectorComponent {
  @Input() frequency = 'WEEKLY';
  @Input() selectedDays: string[] = [];
  @Input() disabled = false;
  @Input() isMonthlyDelivery = false;

  @Output() frequencyChange = new EventEmitter<string>();
  @Output() selectedDaysChange = new EventEmitter<string[]>();

  days = [
    { value: 'sunday', label: 'Su' },
    { value: 'monday', label: 'M' },
    { value: 'tuesday', label: 'T' },
    { value: 'wednesday', label: 'W' },
    { value: 'thursday', label: 'Th' },
    { value: 'friday', label: 'F' },
    { value: 'saturday', label: 'Sa' },
  ];

  onFrequencyChange(event: any): void {
    this.frequency = event.value;
    this.frequencyChange.emit(this.frequency);
  }

  toggleDay(day: string): void {
    const currentSelectedDays = [...this.selectedDays];
    const index = currentSelectedDays.indexOf(day);
    if (index > -1) {
      currentSelectedDays.splice(index, 1);
    } else {
      currentSelectedDays.push(day);
    }
    this.selectedDaysChange.emit(currentSelectedDays);
  }
}
